import { Group, Text, useMantineTheme } from "@mantine/core";
import {
  IconStar,
  IconStarFilled,
  IconStarHalfFilled,
} from "@tabler/icons-react";

interface ReviewStarsProps {
  rating: number;
  size?: number;
  showValue?: boolean;
}

function ReviewStars({
  rating,
  size = 16,
  showValue = false,
}: ReviewStarsProps) {
  const theme = useMantineTheme();
  const stars = [];

  for (let index = 0; index < 5; index += 1) {
    const starNumber = index + 1;

    if (rating >= starNumber) {
      stars.push(
        <IconStarFilled
          key={`star-filled-${starNumber}`}
          size={size}
          color={theme.colors.yellow[6]}
        />,
      );
      continue;
    }

    if (rating >= starNumber - 0.5) {
      stars.push(
        <IconStarHalfFilled
          key={`star-half-${starNumber}`}
          size={size}
          color={theme.colors.yellow[6]}
        />,
      );
      continue;
    }

    stars.push(
      <IconStar
        key={`star-empty-${starNumber}`}
        size={size}
        color={theme.colors.gray[4]}
      />,
    );
  }

  return (
    <Group gap={4} wrap="nowrap">
      <Group gap={3} wrap="nowrap">
        {stars}
      </Group>
      {showValue ? (
        <Text size="sm" fw={700} c={theme.colors.green[8]}>
          {rating.toFixed(1)}
        </Text>
      ) : null}
    </Group>
  );
}

export default ReviewStars;
